import "./App.css";
import {AddTodo} from "./components/Todo"
function App() {
  return (
    <div className="App">
      <AddTodo/>

    </div>
  );
}

export default App;
